<template>
  <v-container class="pa-0">
    <v-container class="wrapper pa-3">
      <v-container class="d-flex justify-start pa-0">
        <v-btn color="primary" outlined @click="openPanelDialog('add')">
          <span>{{ $t("add-new-panel") }}</span>
          <v-icon size="16" class="mr-1">mdi-plus</v-icon>
        </v-btn>
      </v-container>
      <v-container class="pa-0 mt-5 columns">
        <v-container
          class="pa-4 column-panel d-flex justify-space-between align-center mt-2"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="d-flex align-center gap-3">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
            <v-card-text class="pa-0 text-body-2">{{ item.name }}</v-card-text>
          </div>
          <div class="d-flex align-center gap-3">
            <v-card-text
              class="pa-0 text-body-2"
              :style="{ color: item.status == 'active' ? '#137333' : '#ff5252' }"
            >
              {{ $t(item.status) }}
            </v-card-text>
            <v-btn
              outlined
              color="primary"
              height="32"
              @click="openSyncPermission(item, index)"
              :disabled="syncingPanels.includes(index)"
            >
              {{
                syncingPanels.includes(index)
                  ? $t("synchronizing-products") + "..."
                  : $t("synchronize-products")
              }}
            </v-btn>
            <!-- <v-btn
              color="primary"
              outlined
              height="32"
              v-clipboard:copy="`https://integrator.abriron.com/api/mixin/webhook?key=${item.panel_token}`"
              @click="copied"
              :disabled="item.panel_token == null"
            >
              {{ $t('orderWebhook') }}
            </v-btn> -->
            <div @click="openPanelDialog('edit', item)">
              <my-icon
                :name="'edit-icon'"
                :width="16"
                :height="17"
                :stroke="'#000'"
                :cursor-pointer="true"
              />
            </div>
          </div>
        </v-container>
        <v-container class="d-flex justify-space-between pa-0 mt-10">
          <v-btn color="primary" height="32" @click="submit" :loading="loading">
            {{ $t("submit") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog
      v-model="panelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="firstStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") + " " + (selectedPanel ? selectedPanel.name : "")
              }}
            </v-card-text>
            <v-icon size="20" @click="panelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-cente gap-2">
            <v-text-field
              v-model="newPanel.name"
              :label="$t('name')"
              outlined
              height="32"
              dense
              style="width: 0"
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-text-field
              v-model="newPanel.phone"
              :label="$t('mobile')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 mx-0"
              style="width: 151px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPanel(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color': selectedStatusPanel == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPanel == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPanel == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-container class="pa-0 d-flex gap-2 mt-6">
            <v-text-field
              v-model="newPanel.shop_url"
              :label="$t('shop-url')"
              outlined
              height="32"
              dense
              style="width: 0"
              :rules="[(v) => !!v || $t('is-required')]"
              dir="ltr"
              @focus="isUserFocusOnDomain = true"
              @blur="resolveDomainPrefix"
              class="domain-input"
            >
              <template v-slot:prepend-inner>
                <v-card-text
                  :style="{ display: isUserFocusOnDomain ? 'block' : 'none' }"
                  class="text--secondary text-body-2 pa-0 mt-1"
                >
                  https://
                </v-card-text>
              </template>
            </v-text-field>
            <v-text-field
              v-if="newPanel"
              v-model="newPanel.access_token"
              :label="$t('access-token')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
          </v-container>
          <v-container class="pa-0 d-flex gap-2 mb-9 mt-10">
            <div style="width: 70%">
              <v-text-field
                v-if="newPanel"
                v-model="newPanel.currency_coefficient"
                :label="$t('currency_coefficient')"
                outlined
                height="32"
                dense
                :rules="[(v) => !!v || $t('is-required')]"
                type="number"
              />
            </div>
            <div style="width: 30%">
              <!-- <v-btn
                color="primary"
                outlined
                height="32"
                width="100%"
                @click="copyWebHook"
                :disabled="newPanel.panel_token == null"
              >
                {{ $t('orderWebhook') }}
              </v-btn> -->
            </div>
          </v-container>
          <!-- add order history starts at datepicker -->
          <v-container class="pa-0 ma-0 mt-8 align-center" style="width: 277px">
            <v-card-text class="pa-0 text-body-2 mt-1 mb-4">{{
              $t("order_history_start")
            }}</v-card-text>
            <template>
              <template v-if="newPanel">
                <v-text-field
                  id="startDateId"
                  v-model="newPanel.order_history_starts_at"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :label="$t('date')"
                  outlined
                  dense
                  height="32"
                  clearable
                  readonly
                  hide-details="auto"
                  class="rtl-text w-100 pl-3"
                />

                <date-picker
                  v-model="newPanel.order_history_starts_at"
                  element="startDateId"
                  type="datetime"
                  compact-time
                  :locale="$store.state.date_locale"
                  :format="dateTimeFormat"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                      .primary
                  "
                />
              </template>
            </template>
          </v-container>
          <!-- <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("invoice-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <v-select
              v-model="newPanel.confirm_status"
              :label="$t('registerStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.edit_status"
              :label="$t('editStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.destroy_status"
              :label="$t('removeStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.return_sell_status"
              :label="$t('returnSellStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-container> -->
          <v-container class="pa-0 d-flex align-center justify-space-between mt-10">
            <div class="d-flex align-center gap-1">
              <v-btn color="primary" height="32" @click="nextStep">
                {{ $t("next-step") }}
              </v-btn>
              <v-btn color="secondary" outlined height="32" @click="panelDialog = false">
                {{ $t("cancel") }}
              </v-btn>
            </div>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="secondPanelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="secondStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") + " " + (selectedPanel ? selectedPanel.name : "")
              }}
            </v-card-text>
            <v-icon size="20" @click="secondPanelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("warehouse and branch settings")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <autocomplete
              v-model="newPanel.default_branch"
              :title="$t('defaultBranch')"
              type="branch"
              class="flex-fill"
            />
            <autocomplete
              v-model="newPanel.seller_warehouse"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="$t('entrepotToUse')"
              type="entrepot"
              class="flex-fill"
            />
          </v-container>
          <v-container class="d-flex align-center gap-3 pa-0 mb-7 mt-11">
            <v-card-text class="pa-0 text-body-2">{{
              $t("inventory-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusInventoryUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusInventoryUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusInventoryUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusInventoryUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-card-text class="pa-0 text-body-2">{{
              $t("fixed-price-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPriceUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusPriceUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPriceUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPriceUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-container class="pa-0 d-flex align-center justify-space-between">
            <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
              $t("payment-method")
            }}</v-card-text>
            <v-btn color="secondary" outlined @click="addNewPaymentMethod">
              {{ $t("add-new-payment-method") }}
              <v-icon size="20" class="ms-2">mdi-plus</v-icon>
            </v-btn>
          </v-container>
          <v-data-table
            :headers="headers"
            :items="paymentMethodsItems"
            :items-per-page="-1"
            hide-default-footer
            :height="isMobile || isTablet ? 265 : 200"
            fixed-header
            class="paymentTable"
          >
            <template v-slot:item.bank="{ item, index }">
              {{ item.bank.name }}
            </template>
            <template v-slot:item.method="{ item, index }">
              {{ $t(item.method) }}
            </template>
            <template v-slot:header.edit="{ header }">
              <v-container
                class="pa-0 d-flex align-center justify-space-between ma-0 gap-1"
              >
                {{ $t("delete all") }}
                <div style="cursor: pointer" @click="openDeleteDialog('all')">
                  <my-icon
                    :name="'trash-icon'"
                    :width="15"
                    :height="15"
                    :cursor-pointer="true"
                  />
                </div>
              </v-container>
            </template>
            <template v-slot:item.edit="{ item, index }">
              <div
                class="d-flex justify-center"
                style="cursor: pointer"
                @click="openDeleteDialog('single', item)"
              >
                <my-icon
                  :name="'trash-icon'"
                  :width="15"
                  :height="15"
                  :cursor-pointer="true"
                />
              </div>
            </template>
          </v-data-table>
          <v-container class="pa-0 d-flex justify-space-between mt-9">
            <div class="d-flex align-center gap-2">
              <v-btn color="primary" height="32" @click="checkValidation">
                {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
              </v-btn>
              <v-btn color="primary" height="32" outlined @click="prevStep">
                {{ $t("previus-step") }}
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                height="32"
                @click="secondPanelDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </div>
            <v-btn color="error" outlined height="32" @click="openDeleteDialog('panel')">
              <span class="ml-1">{{ $t("delete-panel") }}</span>
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :fill="'#ff5252'"
                :cursor-pointer="true"
              />
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="paymentDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="500"
    >
      <v-card class="pa-5">
        <v-form ref="thirdStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">{{
              $t("add-new-payment-method")
            }}</v-card-text>
            <v-icon size="20" @click="paymentDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <autocomplete
              v-model="paymentMethods.bank"
              :title="$t('bank') + '/' + $t('cash')"
              type="allBankCash"
              :rules="[(v) => !!v || $t('is-required')]"
              :outlined="true"
              :value="paymentMethods.bank"
            />
            <v-select
              v-model="paymentMethods.method"
              :label="$t('method')"
              :items="paymentMethodsOptions"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-12">
            <v-btn color="primary" height="32" @click="addPaymentMethod">
              {{ $t("confirm") }}
            </v-btn>
            <v-btn color="secondary" outlined height="32" @click="paymentDialog = false">
              {{ $t("cancel") }}
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{
            deleteMode == "all"
              ? $t("are you sure you want to delete all items?")
              : deleteMode == "single"
              ? $t("Are you sure you want to delete this item ?")
              : deleteMode == "panel"
              ? $t("do you want to delete this panel ?")
              : ""
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-2 mt-6">
          <v-btn color="error" height="32" @click="remove" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSyncPermission"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from mixin")
          }}</v-card-text>
          <v-icon size="20" @click="productSyncPermission = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 my-8" style="line-height: 25px">
          {{ $t("do you want to sync the panel product information ?") }}
          <br />
          {{ panelName }}
          <br />
          {{ $t("are you sure ?") }}
        </v-card-text>
        <v-container class="pa-0 d-flex gap-2">
          <v-btn color="primary" height="32" @click="synchronization">
            {{ $t("yes, synchronize") }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            height="32"
            @click="productSyncPermission = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSync"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from mixin")
          }}</v-card-text>
          <v-icon size="20" @click="productSync = false">mdi-close</v-icon>
        </v-container>
        <!-- <v-container class="pa-0 d-flex justify-center align-center my-5">
          <img src="@/assets/integrators/sync-digikala.png" />
        </v-container> -->
        <v-container class="pa-0 d-flex justify-center align-center mt-10">
          <v-card-text class="pa-0 text-body-2 text-center" style="line-height: 25px">
            {{ $t("we are syncing panel product information") }}
            {{ panelName }}
            {{ $t("from mixin") }}
            {{ $t("this process may take time. Please be patient.") }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="syncSuccessDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from mixin")
          }}</v-card-text>
          <v-icon size="20" @click="syncSuccessDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-7">
          <img v-if="isUserGaveAccess" src="@/assets/integrators/sync-success.png" />
          <img v-else src="@/assets/integrators/sync-failed.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2">
            {{
              isUserGaveAccess
                ? $t("your connection has been established successfully.")
                : $t(
                    "unfortunately your connection has not been established successfully."
                  )
            }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import MyIcon from "../../components/general/icon/MyIcon.vue";
import General from "../../../../Mixins/general";

export default {
  data() {
    return {
      panelDialog: false,
      secondPanelDialog: false,
      paymentDialog: false,
      selectedStatusPanel: null,
      selectedStatusInventoryUpdate: null,
      selectedStatusPriceUpdate: null,
      snakbar: false,
      snakbarText: null,
      snakbarColor: null,
      dialogType: null,
      valid: true,
      selectedIndex: null,
      deleteDialog: false,
      entrepot: null,
      items: [],
      statusItems: [
        {
          value: "started",
          text: this.$t("sazito-started"),
        },
        {
          value: "shipping",
          text: this.$t("sazitoShipping"),
        },
        {
          value: "shipped",
          text: this.$t("sazitoShipped"),
        },
        {
          value: "complete",
          text: this.$t("sazitoComplete"),
        },
        {
          value: "cancelled",
          text: this.$t("sazitoCancelled"),
        },
      ],
      loading: false,
      newPanel: {
        name: null,
        phone: null,
        status: null,
        shop_url: null,
        access_token: null,
        currency_coefficient: null,
        panel_token: null,
        confirm_status: null,
        edit_status: null,
        destroy_status: null,
        return_sell_status: null,
        default_branch: null,
        seller_warehouse: null,
        inventory_update: null,
        price_update: null,
        payments: [],
      },
      paymentMethods: {
        bank: null,
        method: null,
      },
      paymentMethodsOptions: [
        //
        {
          value: "trobpay",
          text: this.$t("trobpay"),
        },
        {
          value: "aqayepardakht",
          text: this.$t("aqayepardakht"),
        },
        {
          value: "zarinplus",
          text: this.$t("zarin_plus"),
        },
        //
        {
          value: "ayriapayment",
          text: this.$t("ayriapayment"),
        },
        {
          value: "azkipayment",
          text: this.$t("azkipayment"),
        },
        {
          value: "bazarpayment",
          text: this.$t("bazarpayment"),
        },
        {
          value: "cardtocardpayment",
          text: this.$t("cardtocardpayment"),
        },
        {
          value: "digipaypayment",
          text: this.$t("digipaypayment"),
        },
        {
          value: "freepayment",
          text: this.$t("freepayment"),
        },
        {
          value: "mellatpayment",
          text: this.$t("mellatpayment"),
        },
        {
          value: "ozonpayment",
          text: this.$t("ozonpayment"),
        },
        {
          value: "paymentinplacepayment",
          text: this.$t("paymentinplace"),
        },
        {
          value: "paypingpayment",
          text: this.$t("paypingpayment"),
        },
        {
          value: "pecpayment",
          text: this.$t("pecpayment"),
        },
        {
          value: "sadadpayment",
          text: this.$t("sadadpayment"),
        },
        {
          value: "seppayment",
          text: this.$t("seppayment"),
        },
        {
          value: "snapppay",
          text: this.$t("snapppayment"),
        },
        {
          value: "tara",
          text: this.$t("tara"),
        },
        {
          value: "tomanpayment",
          text: this.$t("tomanpayment"),
        },
        {
          value: "uppayment",
          text: this.$t("uppayment"),
        },
        {
          value: "vandarpayment",
          text: this.$t("vandarpayment"),
        },
        {
          value: "zarinpal",
          text: this.$t("zarinpal"),
        },
        {
          value: "zibalpayment",
          text: this.$t("zibalpayment"),
        },
        {
          value: "zifypayment",
          text: this.$t("zifypayment"),
        },
      ],
      headers: [],
      paymentMethodsItems: [],
      deleteMode: null,
      newSelectedMethod: null,
      selectedPanel: null,
      isUserFocusOnDomain: false,
      productSyncPermission: false,
      panelName: null,
      productSync: null,
      selectedSyncPanel: null,
      syncingPanels: [],
      syncSuccessDialog: false,
      isUserGaveAccess: false,
      wantedSyncPanel: null,
    };
  },
  mixins: [General],
  methods: {
    copyWebHook() {
      const text = `https://integrator.abriron.com/api/mixin/webhook?key=${this.newPanel.panel_token}`;
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.copied();
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    },
    fetchPanelList() {
      var app = this;
      app.$axios
        .get(this.$endpoint + "mixin/get-config")
        .then((r) => {
          this.items = r.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    openPanelDialog(type, selectedItem) {
      this.panelDialog = true;
      if (type == "add") {
        this.clearForm();
        this.newPanel.currency_coefficient = 1;
        this.dialogType = "add";
      }
      if (type == "edit" && selectedItem) {
        this.dialogType = "edit";
        this.isUserFocusOnDomain = true;
        this.selectedPanel = selectedItem;
        this.newPanel.panel_token = selectedItem.panel_token;
        //put inputs in forms
        this.newPanel = {
          id: selectedItem.id,
          name: selectedItem.name,
          phone: selectedItem.phone,
          status: selectedItem.status,
          shop_url: selectedItem.shop_url,
          access_token: selectedItem.access_token,
          currency_coefficient: selectedItem.currency_coefficient,
          panel_token: selectedItem.panel_token,
          confirm_status: selectedItem.confirm_status,
          edit_status: selectedItem.edit_status,
          destroy_status: selectedItem.destroy_status,
          return_sell_status: selectedItem.return_sell_status,
          default_branch: selectedItem.default_branch,
          seller_warehouse: selectedItem.seller_warehouse,
          inventory_update: selectedItem.inventory_update,
          price_update: selectedItem.price_update,
          payments: selectedItem.payments,
          order_history_starts_at: selectedItem.order_history_starts_at,
        };
        this.selectedStatusPanel = selectedItem.status;
        this.selectedStatusInventoryUpdate = selectedItem.inventory_update;
        this.selectedStatusPriceUpdate = selectedItem.price_update;

        //put payments in data table
        this.paymentMethodsItems = this.newPanel.payments;

        this.selectedIndex = this.items.findIndex(
          (item) => item.access_token == selectedItem.access_token
        );
        /* console.log('selected index' + this.selectedIndex) */
      }
    },
    selectStatusPanel(item) {
      this.selectedStatusPanel = item.value;
      this.newPanel.status = this.selectedStatusPanel;
    },
    selectStatusInventoryUpdate(item) {
      this.selectedStatusInventoryUpdate = item.value;
      this.newPanel.inventory_update = this.selectedStatusInventoryUpdate;
    },
    selectStatusPriceUpdate(item) {
      this.selectedStatusPriceUpdate = item.value;
      this.newPanel.price_update = this.selectedStatusPriceUpdate;
    },
    nextStep() {
      if (this.$refs.firstStep.validate()) {
        this.panelDialog = false;
        this.secondPanelDialog = true;
        if (this.dialogType == "add") {
          this.selectedStatusInventoryUpdate = "active";
          this.selectedStatusPriceUpdate = "active";
          this.newPanel.inventory_update = this.selectedStatusInventoryUpdate;
          this.newPanel.price_update = this.selectedStatusPriceUpdate;
        }
      }
    },
    prevStep() {
      this.secondPanelDialog = false;
      this.panelDialog = true;
    },
    checkValidation() {
      if (this.$refs.secondStep.validate() && this.dialogType == "add") {
        this.addPanel();
      }
      if (this.$refs.secondStep.validate() && this.dialogType == "edit") {
        this.editPanel();
      }
    },
    addPanel() {
      const sameObject = this.items.some(
        (item) => item.access_token == this.newPanel.access_token
      );
      if (!sameObject) {
        // add columns (show)
        this.items.push(this.newPanel);
        this.secondPanelDialog = false;
        /* console.log('items after add' + JSON.stringify(this.items)) */
      } else {
        this.snakbarText = this.$t("duplicate mixin token");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    editPanel() {
      // edit column (show)
      this.items.splice(this.selectedIndex, 1, this.newPanel);
      this.secondPanelDialog = false;
      /* console.log('items after edit' + JSON.stringify(this.items)) */
    },
    clearForm() {
      this.newPanel = {
        id: null,
        name: null,
        phone: null,
        status: null,
        shop_url: null,
        access_token: null,
        currency_coefficient: null,
        panel_token: null,
        confirm_status: null,
        edit_status: null,
        destroy_status: null,
        return_sell_status: null,
        default_branch: null,
        seller_warehouse: null,
        inventory_update: null,
        price_update: null,
        order_history_starts_at: null,
        payments: [],
      };
      // reset toggle button
      this.selectedStatusPanel = "active";
      this.selectedStatusInventoryUpdate = "active";
      this.selectedStatusPriceUpdate = "active";

      this.newPanel.status = this.selectedStatusPanel;
      this.newPanel.inventory_update = this.selectedStatusInventoryUpdate;
      this.newPanel.price_update = this.selectedStatusPriceUpdate;

      // reset form
      if (this.$refs.firstStep && this.$refs.secondStep && this.$refs.thirdStep) {
        this.$refs.firstStep.reset();
        this.$refs.secondStep.reset();
        this.$refs.thirdStep.reset();
      }

      this.paymentMethodsItems = [];
      this.newPanel.payments = [];
    },
    addNewPaymentMethod() {
      this.paymentDialog = true;
    },
    addPaymentMethod() {
      this.paymentMethodsItems.push(this.paymentMethods);
      /* console.log('1' + JSON.stringify(this.paymentMethodsItems)) */

      this.newPanel.payments = this.paymentMethodsItems;
      /* console.log('2' + JSON.stringify(this.paymentMethodsItems)) */

      /* console.log('newpanel after add'+ JSON.stringify(this.newPanel)) */
      this.paymentDialog = false;
      this.paymentMethods = {
        bank: null,
        method: null,
      };
      // reset form
      this.$refs.thirdStep.reset();
      /* console.log('table after add' + JSON.stringify(this.paymentMethodsItems)) */
    },
    openDeleteDialog(type, selectedMethod) {
      if (type == "all") {
        this.deleteMode = "all";
        this.deleteDialog = true;
      }
      if (type == "single" && selectedMethod != null) {
        this.deleteMode = "single";
        this.deleteDialog = true;
        this.newSelectedMethod = selectedMethod;
        /* console.log(JSON.stringify(this.newSelectedMethod)) */
      }
      if (type == "panel") {
        if (this.dialogType == "add") {
          this.secondPanelDialog = false;
          this.clearForm();
        }
        if (this.dialogType == "edit") {
          this.deleteMode = "panel";
          this.deleteDialog = true;
        }
      }
    },
    submit() {
      const itemsToSend = JSON.parse(JSON.stringify(this.items));
      const updatedItems = itemsToSend.map((item) => {
        let updatedShopUrl = item.shop_url;
        if (!item.shop_url.startsWith("https://")) {
          updatedShopUrl = "https://" + item.shop_url;
        }

        return {
          ...item,
          shop_url: updatedShopUrl,
        };
      });
      // post api
      this.loading = true;
      var app = this;
      app.$axios
        .post(this.$endpoint + "mixin/store-config", updatedItems)
        .then((r) => {
          this.loading = false;
          this.snakbarText = this.$t("new panel successfully added");
          this.snakbarColor = "green";
          this.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    remove() {
      if (this.deleteMode == "all") {
        this.paymentMethodsItems = [];
        this.newPanel.payments = [];
        this.deleteDialog = false;
      }
      if (this.deleteMode == "single") {
        const indexTable = this.paymentMethodsItems.findIndex(
          (item) =>
            item.method == this.newSelectedMethod.method &&
            item.bank.name == this.newSelectedMethod.bank.name
        );
        if (indexTable != -1) {
          this.paymentMethodsItems.splice(indexTable, 1);
        }
        const indexPanel = this.newPanel.payments.findIndex(
          (item) =>
            item.method == this.newSelectedMethod.method &&
            item.bank.name == this.newSelectedMethod.bank.name
        );
        if (indexPanel != -1) {
          this.newPanel.payments.splice(indexPanel, 1);
        }
        this.deleteDialog = false;
      }
      if (this.deleteMode == "panel") {
        this.deletePanel();
      }
    },
    deletePanel() {
      // delete api
      this.loading = true;
      const id = this.items[this.selectedIndex].id;
      /* console.log(id) */
      if (id != null) {
        var app = this;
        app.$axios
          .delete(this.$apipoint + `config/destroy/${id}`)
          .then((r) => {
            if (r.data.status == "success") {
              this.loading = false;
              this.items.splice(this.selectedIndex, 1);
              this.deleteDialog = false;
              this.panelDialog = false;
              this.secondPanelDialog = false;
              this.snakbarText = this.$t("your panel removed successfully");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          });
      } else {
        this.items.splice(this.selectedIndex, 1);
        this.panelDialog = false;
        this.secondPanelDialog = false;
        this.loading = false;
        this.deleteDialog = false;
        this.snakbarText = this.$t("your panel removed successfully");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    resolveDomainPrefix() {
      if (this.isUserFocusOnDomain && this.newPanel.shop_url.length > 0) {
        this.isUserFocusOnDomain = true;
      }
      if (this.isUserFocusOnDomain && this.newPanel.shop_url.length == 0) {
        this.isUserFocusOnDomain = false;
      }
    },
    openSyncPermission(item, index) {
      var app = this;
      app.$axios
        .get(this.$endpoint + "mixin/get-config")
        .then((r) => {
          this.items = r.data;
          this.wantedSyncPanel = this.items.find(
            (obj) => obj.name == item.name && obj.status == item.status
          );
          console.log(this.wantedSyncPanel.panel_token);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
      this.productSyncPermission = true;
      this.panelName = item.name;
      this.selectedSyncPanel = index;
    },
    synchronization() {
      // call api
      this.pullingProduct();
      this.productSyncPermission = false;
      this.productSync = true;

      if (!this.syncingPanels.includes(this.selectedSyncPanel)) {
        this.syncingPanels.push(this.selectedSyncPanel);
      }
    },
    pullingProduct() {
      var app = this;
      app.$axios
        .post("https://integrator.abriron.com/api/" + "mixin/pulling-product", {
          panel_token: this.wantedSyncPanel.panel_token,
          url: this.wantedSyncPanel.shop_url,
        })
        .then((r) => {
          if (r.data && r.data.error) {
            this.snakbar = true;
            this.snakbarText = r.data.error;
            this.snakbarColor = "red";
          }
        })
        .catch((error) => {
          const serverError = error.response?.data?.error || "خطای ناشناخته از سمت سرور";
          this.snakbar = true;
          this.snakbarText = serverError;
          this.snakbarColor = "red";
        });
    },
  },
  mounted() {
    this.fetchPanelList();
  },
  components: {
    MyIcon,
  },
  computed: {
    dateTimeFormat() {
      return this.$store.state.date_locale === "fa,en"
        ? "jYYYY/jMM/jDD HH:mm"
        : "YYYY/MM/DD HH:mm";
    },
    activatorOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    invoiceOptions() {
      return [
        { label: this.$t("registration-of-returned-invoice"), value: "register" },
        { label: this.$t("delete-invoice"), value: "delete" },
      ];
    },
    webhookUrl() {
      return `https://integrator.abriron.com/api/mixin/webhook?key=${this.newPanel.panel_token}`;
    },
  },
  watch: {},
  beforeMount() {
    this.headers = [
      {
        text: this.$t("bank-or-fund"),
        align: "start",
        sortable: false,
        value: "bank",
        width: "40%",
      },
      {
        text: this.$t("payment-method"),
        align: "start",
        sortable: false,
        value: "method",
        width: "40%",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
        width: "10%",
      },
    ];
  },
};
</script>

<style scoped>
.wrapper {
  background-color: #fcfcfc;
}
.wrapper .columns .column-panel {
  border: 1px solid silver;
  border-radius: 4px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
::v-deep .v-data-table.paymentTable .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.paymentTable {
  border: 1px solid silver;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  /* background-color: #eeeeee; */
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
  border-left: 1px solid silver;
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
.domain-input.v-text-field ::v-deep .v-label.v-label--active {
  right: 0px !important;
}
::v-deep .v-input__prepend-inner {
  position: absolute;
  left: 9px;
  direction: ltr;
}
.domain-input.v-text-field
  ::v-deep
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input {
  margin-left: 48px;
}
</style>
